import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Typography,
} from "@mui/material";
import { getAllTicketsByCriteria } from "src/apis/tickets";
import "./Tags.css";
import Checkbox from "@mui/material/Checkbox";
import { ticketImpacts, ticketStatuses } from "src/util/utility_enums";
import ListItemText from "@mui/material/ListItemText";
import { fetchTicketStatus } from "src/apis/tickets";
import FormControlLabel from "@mui/material/FormControlLabel";
import Chip from "@mui/material/Chip";

const TicketFilter = ({ props }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedSeverity, setSelectedSeverity] = useState(0);

  const [selectedAssets, setSelectedAssets] = useState(null);
  const [selectedBuildings, setSelectedBuildings] = useState(null);
  const [selectedSites, setSelectedSites] = useState(null);
  const [selectedOperator, setSelectedOperator] = useState(null);
  const [selectedMntEmail, setSelectedMntEmail] = useState(null);
  const [Onerousity, setOnerousity] = useState(false);
  const formRef = useRef(null);
  const externalSubmit = props.externalSubmit;

  useEffect(() => {
    if (externalSubmit) {
      formRef.current?.dispatchEvent(
        new Event("submit", { cancelable: true, bubbles: true })
      );
    }
  }, [externalSubmit]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    // let data = {
    //   assetId: null,
    //   buildingId: null,
    //   endDateStr: null,
    //   isOnerous: null,
    //   mntOperatorEmail: null,
    //   operatorId: null,
    //   organizationId: null,
    //   siteId: null,
    //   startDateStr:null,
    //   statusId: selectedStatus,
    // };

    let data = {
      endDateStr: endDate === null ? endDate : endDate + " 00:00:00",
      startDateStr: startDate === null ? startDate : startDate + " 00:00:00",
      isOnerous: !Onerousity ? null : Onerousity,
      assetId: selectedAssets,
      buildingId: selectedBuildings,
      mntOperatorEmail: selectedMntEmail,
      operatorId: selectedOperator,
      siteId: selectedSites,
      statusId: selectedStatus,
      organizationId: 1,
    };

    var response;
    var message;

    //APIS CALLING
    response = await fetchTicketStatus(data);

    console.log("submit:" + JSON.stringify(response));
    if (response === undefined) {
      alert.setError((prev) => [...prev,{ status: true, messages: response.errors,index:prev.length }]);
      return props.onSubmit(false, false);
    }

    return props.onSubmit(true, response);
  };

  const handleChange = (event) => {
    setSelectedAssets(event.target.value);
  };

  const handleChange2 = (event) => {
    setEndDate(event.target.value);
  };

  return (
    <form
      className="TicketingTagsContainer"
      ref={formRef}
      onSubmit={handleSubmit}
    >
      <Grid container>
        <Grid md={6}>
          <div className="filterItems">
            From:{" "}
            <TextField
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
        </Grid>
        <Grid md={6}>
          <div className="filterItems">
            To:{" "}
            <TextField
              type="date"
              value={endDate}
              onChange={handleChange2}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
        </Grid>
        {/* <Grid xs={12}>
            <div className="filterItems">
              <Typography width={"25%"}>Ticket Severity:</Typography>
              <Select
                autoWidth={true}
                // multiple
                value={selectedSeverity}
                onChange={(e) => setSelectedSeverity(e.target.value)}
                renderValue={(selected) =>
                  selected.map((value, i) =>
                    i === selected.length - 1
                      ? ticketImpacts[value - 1].name
                      : ticketImpacts[value - 1].name + ", "
                  )
                }
              >
                {ticketImpacts.map((status) => (
                  <MenuItem value={status.id}>
                    <Checkbox checked={selectedSeverity.includes(status.id)} />
                    <ListItemText primary={status.name} />
                  </MenuItem>
                ))}
              </Select>
            </div>
          </Grid> */}

        <Grid xs={12}>
          <div className="filterItems">
            <Typography width={"25%"}>Ticket Status:</Typography>
            <Select
              autoWidth={true}
              // multiple
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
              renderValue={(value) => (
                // selected.map((value, i) =>
                //   i === selected.length - 1
                //     ? ticketStatuses[value - 1].name
                //     : ticketStatuses[value - 1].name + ", "
                // )
                <Typography className="text-truncate">
                  {value === 0 ? null : ticketStatuses[value - 1].name}
                </Typography>
              )}
            >
              {ticketStatuses.map((status) => (
                <MenuItem value={status.id}>
                  {/* <Checkbox checked={selectedStatus.includes(status.id)} /> */}
                  <Checkbox checked={selectedStatus === status.id} />

                  <ListItemText primary={status.name} />
                </MenuItem>
              ))}
            </Select>
          </div>
        </Grid>

        <Grid md={6} sm={6} xs={12}>
          <div className="filterItems">
            Asset:
            <Select
              value={selectedAssets}
              onChange={handleChange}
              renderValue={(value) => (
                // selected.map((value, i) =>
                //   i === selected.length - 1
                //     ? ticketStatuses[value - 1].name
                //     : ticketStatuses[value - 1].name + ", "
                // )
                <Typography className="text-truncate">
                  {value === 0
                    ? null
                    : props.assets.find((x) => x.id === value).name}
                </Typography>
              )}
            >
              {props.assets.map((asset) => (
                <MenuItem value={asset.id}>
                  {/* <Checkbox checked={selectedAssets.includes(asset.id)} /> */}
                  <Checkbox checked={selectedAssets === asset.id} />
                  <ListItemText primary={asset.name} />
                </MenuItem>
              ))}
            </Select>
          </div>
        </Grid>
        <Grid md={6} sm={6} xs={12}>
          <div className="filterItems">
            Building:
            <Select
              // multiple
              value={selectedBuildings}
              onChange={(e) => setSelectedBuildings(e.target.value)}
              renderValue={(value) => (
                // selected.map((value, i) =>
                //   i === selected.length - 1
                //     ? ticketStatuses[value - 1].name
                //     : ticketStatuses[value - 1].name + ", "
                // )
                <Typography className="text-truncate">
                  {value === 0
                    ? null
                    : props.buildings.find((x) => x.id === value).name}
                </Typography>
              )}
            >
              {props.buildings.map((building) => (
                <MenuItem value={building.id}>
                  <Checkbox checked={selectedBuildings === building.id} />
                  <ListItemText primary={building.name} />
                </MenuItem>
              ))}
            </Select>
          </div>
        </Grid>
        <Grid md={6} sm={6} xs={12}>
          <div className="filterItems">
            Manteinance Operator Email:
            <Select
              // multiple
              value={selectedMntEmail}
              onChange={(e) => setSelectedMntEmail(e.target.value)}
              renderValue={(value) => (
                // selected.map((value, i) =>
                //   i === selected.length - 1
                //     ? ticketStatuses[value - 1].name
                //     : ticketStatuses[value - 1].name + ", "
                // )
                <Typography className="text-truncate">
                  {value === 0
                    ? null
                    : props.mntEmails.find((x) => x === value)}
                </Typography>
              )}
            >
              {props.mntEmails.map((email) => (
                <MenuItem value={email}>
                  <Checkbox checked={selectedMntEmail === email} />
                  <ListItemText primary={email} />
                </MenuItem>
              ))}
            </Select>
          </div>
        </Grid>
        <Grid md={6} sm={6} xs={12}>
          <div className="filterItems">
            Operator:
            <Select
              // multiple
              value={selectedOperator}
              onChange={(e) => setSelectedOperator(e.target.value)}
              renderValue={(value) => (
                // selected.map((value, i) =>
                //   i === selected.length - 1
                //     ? ticketStatuses[value - 1].name
                //     : ticketStatuses[value - 1].name + ", "
                // )
                <Typography className="text-truncate">
                  {value === 0
                    ? null
                    : props.operators.find((x) => x.id === value).name}
                </Typography>
              )}
            >
              {props.operators.map((operator) => (
                <MenuItem value={operator.id}>
                  <Checkbox checked={selectedOperator === operator.id} />
                  <ListItemText primary={operator.name} />
                </MenuItem>
              ))}
            </Select>
          </div>
        </Grid>
        <Grid md={6} sm={6} xs={12}>
          <div className="filterItems">
            Site:
            <Select
              // multiple
              value={selectedSites}
              onChange={(e) => setSelectedSites(e.target.value)}
              renderValue={(value) => (
                // selected.map((value, i) =>
                //   i === selected.length - 1
                //     ? ticketStatuses[value - 1].name
                //     : ticketStatuses[value - 1].name + ", "
                // )
                <Typography className="text-truncate">
                  {value === 0
                    ? null
                    : props.sites.find((x) => x.id === value).name}
                </Typography>
              )}
            >
              {props.sites.map((site) => (
                <MenuItem value={site.id}>
                  <Checkbox checked={selectedSites === site.id} />
                  <ListItemText primary={site.name} />
                </MenuItem>
              ))}
            </Select>
          </div>
        </Grid>
        <Grid md={6} sm={6} xs={12}>
          <div className="filterItems">
            <FormControlLabel
              control={
                <Checkbox
                  checked={Onerousity}
                  onChange={(e) => setOnerousity(e.target.checked)}
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
              label="Onerous"
            />
          </div>
        </Grid>
        <Grid md={6} sm={6} xs={12}>
          <div className="filterItems">
            <FormControlLabel
              control={
                <Checkbox
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
              label="Default"
            />
          </div>
        </Grid>
        <Grid md={12}></Grid>
      </Grid>
    </form>
  );
};

export default TicketFilter;
